angular.
module("dx.webapp.lti").
controller("DxExamSelectedRouteController", function ExamSelectedRouteController(
	$http,
	$location,
	$rootScope,
	$routeParams,

	DX_GRADING_TYPES,
	dxLtiRoute,
	ExamRepository,
	DX_URLS,

	dxLocalize
) {
	"use strict";

	var self = this;

	this.examTitle = "";
	this.maxScore = 0;
	this.isScoreBased = true;
	this.dxLtiRoute = dxLtiRoute;

	var examId = $routeParams.examId || 0;

	ExamRepository.load(examId).then(function success(exam) {
		self.examTitle = exam.title;
		self.maxScore = exam.maxScore();
		self.isScoreBased = exam.gradingType === DX_GRADING_TYPES.SCORE;
	}, function failed() {
		$location.path(DX_URLS.get(404));
	});

	this.confirm = function confirm() {
		$http.post("/lti/embed", {
			contextId: $routeParams.context_id,
			contextTitle: $routeParams.context_title,
			toolConsumerInstanceGuid: $routeParams.tool_consumer_instance_guid,
			toolConsumerInstanceName: $routeParams.tool_consumer_instance_name,
			data: $routeParams.data,
			contentItemReturnUrl: $routeParams.content_item_return_url,
			qh: $routeParams.qh,
			examId: parseInt($routeParams.examId, 10),
		}).then(success, failed);

		function success(response) {
			var form = angular.element("<form />").attr({
				method: "post",
				action: $routeParams.content_item_return_url.split("?")[0],
			});

			for (var key in response.data) {
				if (response.data.hasOwnProperty(key)) {
					var hiddenField = angular.element("<input />");
					hiddenField.attr("type", "hidden");
					hiddenField.attr("name", key);
					hiddenField.attr("value", response.data[key][0]);

					form.append(hiddenField);
				}
			}

			angular.element("body").append(form);
			form.submit();
		}

		function failed() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("UnknownErrorTryAgain"));
		}
	};
});
